<div class="feedback-survey-list">
  <fuse-not-found *ngIf="(analyticsService.feedback$ | async).data.length === 0"></fuse-not-found>
  <fuse-feedback-survey-item
    *ngFor="let item of (analyticsService.feedback$ | async).data"
    [feedback]="item"
    class="feedback-survey-item"
  ></fuse-feedback-survey-item>
</div>
